<template>
  <div>
    <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="disabled" :class="{
      'is-disabled': disabled
    }">
      <section>
        <div class="flex-align-center mb10">
          <label>抽取</label>
          <el-form-item prop="drawCountLimit"><el-input v-model="ruleForm.drawCountLimit" style="width: 80px;" disabled /></el-form-item>
          <label>个数值</label>
        </div>
      </section>
      
      <section>
        <div class="flex-align-center mb10">
          <label>抽取范围</label>
          <el-form-item prop="min"><el-input v-model="ruleForm.min" type="number" style="width: 100px;" placeholder="最小值" /></el-form-item>
          <label>到</label>
          <el-form-item prop="max"><el-input v-model="ruleForm.max" type="number" style="width: 100px;" placeholder="最大值" /></el-form-item>
          <label>，间隔</label>
          <el-form-item prop="step" style="width: 100px;">
            <el-select v-model="ruleForm.step" placeholder="请选择">
              <el-option label="0.01" :value="0.01" />
              <el-option label="0.1" :value="0.1" />
              <el-option label="1" :value="1" />
            </el-select>
          </el-form-item>
        </div>

        <div class="flex-align-center flex-space-between mb10">
          <span class="highlight">只允许填写数字，支持 0、正值。最多保留 2 位小数。<br />数值范围：{{ min }} 到 {{ max }} 之间</span>
          <el-button :disabled="!canCreate" type="primary" @click="handleCreate">放入抽签池</el-button>
        </div>
      </section>

      <section>
        <div class="flex-align-center draw-delete-pool mb10">
          <label class="highlight" style="width: 80px;">已删除数字</label>
          <div class="draw-numbers">
            <div
              v-for="(item, index) in drawDeleteNumbers"
              :key="item"  
              class="draw-number is-delete" @click="handleReset(index)">
              <span>{{ item }}</span>
              <i class="el-icon-close" />
            </div>
          </div>
        </div>
      </section>

      <section class="draw-pool mb10">
        <div class="draw-numbers">
          <div
            v-for="(item, index) in drawNumbers"
            :key="item"  
            class="draw-number" @click="handleDelete(index)">
            <span>{{ item }}</span>
            <i class="el-icon-close" />
          </div>
        </div>
      </section>
      
      <section class="flex-center">
        <el-button :disabled="!canClear" class="btn-clear" @click="handleClear">全部清空</el-button>
        <el-button :disabled="!canSubmit" type="primary" @click="handleSubmit">确认</el-button>
      </section>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    defaultDrawNumbers: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => ({
        numberType: 1,
        numberStart: null,
        numberEnd: null,
        numberInterval: null,
        drawCountLimit: 1
      })
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateMin = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入最小值'))
      } else if (Number(value) < this.min || Number(value) > this.max){
        callback(new Error(this.min + ' 到 ' + this.max + ' 之间'))
      } else if (this.ruleForm.max) {
        if (Number(value) > Number(this.ruleForm.max)) {
          callback(new Error('不能大于最大值'))
        } else if (this.ruleForm.step === 0.01 && Number(this.ruleForm.max) - Number(value) > 20) {
          callback(new Error('最大值与最小值之差不能大于 20'))
        } else {
          this.$refs.ruleForm.clearValidate('max')
          callback();
        }
      } else {
        callback();
      }
    };
    const validateMax = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入最大值'))
      } else if (Number(value) < this.min || Number(value) > this.max) {
        callback(new Error(this.min + ' 到 ' + this.max + ' 之间'))
      } else if (this.ruleForm.min) {
        if (Number(value) < Number(this.ruleForm.min)) {
          callback(new Error('不能小于最小值'))
        } else if (this.ruleForm.step === 0.01 && Number(value) - Number(this.ruleForm.min) > 20) {
          callback(new Error('最大值与最小值之差不能大于 20'))
        } else {
          this.$refs.ruleForm.clearValidate('min')
          callback();
        }
      } else {
        callback();
      }
    };
    const validateStep = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择间隔'))
      } else {
        if (Number(value) === 0.01 && this.ruleForm.max && this.ruleForm.min) {
          if (Number(this.ruleForm.max) - Number(this.ruleForm.min) > 20) {
            this.$refs.ruleForm.validateField('max')
          }
        } else if (Number(this.ruleForm.max) - Number(this.ruleForm.min) > 20){
          this.$refs.ruleForm.clearValidate('min')
          this.$refs.ruleForm.clearValidate('max')
        }
        callback()
      }
    };
    return {
      ruleForm: {
        drawCountLimit: 1,
        min: '',
        max: '',
        step: null
      },
      rules: {
        drawCountLimit: [
          { required: true, message: '请输入', trigger: 'change' },
        ],
        min: [
          // { required: true, message: '请输入最小值', trigger: 'change' }
          { validator: validateMin, trigger: 'change' }
        ],
        max: [
          // { required: true, message: '请输入最大值', trigger: 'change' }
          { validator: validateMax, trigger: 'change' }
        ],
        step: [
          // { required: true, message: '请选择间隔', trigger: 'change' },
          { validator: validateStep, trigger: 'change' }
        ]
      },

      min: 0,
      max: 100,
      drawNumbers: [], // 抽签池数字列表
      drawDeleteNumbers: [] // 已删除的数字
    };
  },

  computed: {
    canCreate() {
      return !this.disabled && (this.ruleForm.min && this.ruleForm.max && this.ruleForm.step)
    },
    canClear() {
      return !this.disabled && (this.drawNumbers.length > 0 || this.drawDeleteNumbers.length > 0)
    },
    canSubmit() {
      return !this.disabled && (this.drawNumbers.length > 0)
    }
  },

  watch: {
    defaultDrawNumbers: {
      handler(val) {
        console.log('defaultDrawNumbers', val)
        this.drawNumbers = [...val]
      },
      immediate: true
    },
    config: {
      handler(val) {
        if (!val) return
        const {
          numberStart: min,
          numberEnd: max,
          numberInterval: step,
          drawCountLimit = 1
        } = val
        this.ruleForm = { min, max, step, drawCountLimit }
      },
      immediate: true
    }
  },

  methods: {
    // 根据最大值、最小值、间隔生成抽签池数字列表，避免小数精度问题
    generateNumbers() {
      const { min, max, step } = this.ruleForm
      const precision = step.toString().split('.')[1] ? step.toString().split('.')[1].length : 0
      const minNum = Number(min)
      const maxNum = Number(max)
      const stepNum = Number(step)
      const drawNumbers = []

      let i = minNum
      while (i <= maxNum) {
        const num = i.toFixed(precision)
        drawNumbers.push(num)
        i = Number((i + stepNum).toFixed(precision))
      }
      this.drawNumbers = drawNumbers
    },
    handleCreate() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return false
        this.handleClear()
        this.generateNumbers()
      });
    },
    handleDelete(index) {
      const number = this.drawNumbers[index]
      this.insertNumber(number, this.drawDeleteNumbers)
      this.drawNumbers.splice(index, 1)
    },
    handleReset(index) {
      const number = this.drawDeleteNumbers[index]
      this.insertNumber(number, this.drawNumbers)
      this.drawDeleteNumbers.splice(index, 1)
    },
    handleClear() {
      this.drawNumbers = []
      this.drawDeleteNumbers = []
      this.$emit('clear')
    },
    handleSubmit() {
      if (this.drawNumbers.length === 0) {
        this.$message.error('请添加抽签池数据！')
        return
      }
      this.$emit('submit', this.drawNumbers, this.ruleForm)
    },
    // 将指定数字插入正序排列的数组中
    insertNumber(number, list) {
      if (list.length === 0) {
        list.push(number)
        return
      }
      for (let i = 0; i < list.length; i++) {
        if (Number(number) < Number(list[i])) {
          list.splice(i, 0, number)
          return
        }
      }
      list.push(number)
    }
  }
}
</script>

<style scoped lang='scss'>
.highlight {
  color: #0060b2;
}
.mb10 {
  margin-bottom: 10px;
}
.mt10 {
  margin-top: 10px;
}
.flex-space-between {
  display: flex;
  justify-content: space-between;
}
.flex-align-center {
  display: flex;
  align-items: center;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-form--inline .el-form-item {
  margin-right: 10px;
  margin-bottom: 0;
}
::v-deep .el-form-item__error {
  color: #F56C6C;
  padding-top: 1px;
  width: 200px;
}
::v-deep .el-form-item.is-error .el-input__inner {
  border-color: #F56C6C;
}
::v-deep .el-form-item .el-input__inner {
  padding-right: 0;
}

section {
  label {
    margin-right: 10px;
    line-height: 26px;
  }
}
.draw-pool {
  width: 100%;
  height: 120px;
  overflow: hidden;
  background-color: rgba(15, 108, 203, 0.05);
  padding: 10px;
  position: relative;

  .draw-numbers {
    height: 100%;
    overflow-y: auto;
  }

  .btn-clear{
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 80px;
    z-index: 1;
  }
}
.draw-numbers {
  flex: 1;

  .draw-number {
    margin: 2px 5px 2px 0;
    padding: 2px 5px;
    display: inline-block;
    border: 1px solid #0f6ccb;
    border-radius: 4px;

    span {
      margin-right: 5px;
    }

    .el-icon-close {
      cursor: pointer;
      &:hover {
        color: #f56c6c;
      }
    }
  }
}

.el-form.is-disabled {
  .el-icon-close {
    display: none;
  }
}
</style>
